module.exports = __webpack_public_path__ + "static/spielbeschreibung-a5202f4c6daab13617a95c808e73051b.pdf";